import React, { useEffect } from 'react'
import { AboutUsProps } from './type'
import { Column, Container, Row } from '@/components/base/gridview'
import { path, useApp } from '@wap-client/core'
import Image from '@/components/base/image'

const AboutUs: React.FC<AboutUsProps> = ({
  title,
  slogan,
  description,
  background,
  image,
}) => {
  const app = useApp()

  useEffect(() => {
    document.body.style.direction = app.language === 'ar-sa' ? 'rtl' : ''
  })

  return (
    <div
      style={{
        background: `url(${path.asset(
          app.environment,
          background?.src
        )}) no-repeat center center`,
        backgroundSize: 'cover',
      }}
      className="stg-aboutus"
    >
      <Container size="extended" className="stg-aboutus-container">
        <Row
          className="stg-aboutus-row"
          xl={{ align: 'center', justify: 'between' }}
        >
          <Column className="stg-aboutus-column">
            <div className="stg-aboutus-main">
              <div className="stg-aboutus-texts">
                <div className="stg-aboutus-title">{title}</div>
                <div className="stg-aboutus-slogan-parent">
                  <div className="slogan">{slogan}</div>
                </div>
                {description && (
                  <div
                    className="stg-aboutus-description"
                    dangerouslySetInnerHTML={{ __html: description }}
                  />
                )}
              </div>
              <div className="stg-aboutus-image">
                <div className="stg-aboutus-image-img">
                  <Image {...image} alt="" />
                </div>
              </div>
            </div>
          </Column>
        </Row>
      </Container>
    </div>
  )
}

export default AboutUs
